export interface RadioConfig {
  id?: string;
  type?: 'radio';
  color?: 'primary' | 'success' | 'danger' | 'orange';
  size?: 'sm' | 'md' | 'lg';
  options?: RadioItem[];
}
export interface RadioItem {
  disabled?: boolean;
  label?: string;
  checked?: boolean; // whether the radio button is selected
  name?: string; // shared across a group's items so the browser treats them as mutually exclusive
  value?: string | number; // value rendered on the input, so a caller can map a selection back to its own model
  secondaryText?: string; // optional text displayed below the label
  anchorText?: string;  // optional text for a link displayed next to the radio button
  link?: string; // optional URL for the anchorText link
}

export const DEFAULT_RADIO_ITEM: RadioItem = {
  disabled: false,
  label: '',
  checked: false,
  secondaryText: '',
  anchorText: '',
  link: '',
  name: ''
};

export const DEFAULT_RADIO_CONFIG: RadioConfig = {
  id: 'radio',
  type: 'radio',
  color: 'primary',
  size: 'md',
  options: [DEFAULT_RADIO_ITEM]
};